var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "aria-label": "Chevron Down",
    fill: "currentColor",
    focusable: "false",
    role: "img",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "css-mrfj8c",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,17c-0.1279297,0-0.2558594-0.0488281-0.3535156-0.1464844l-8-8 c-0.1953125-0.1953125-0.1953125-0.5117188,0-0.7070312s0.5117188-0.1953125,0.7070312,0L12,15.7929688l7.6464844-7.6464844 c0.1953125-0.1953125,0.5117188-0.1953125,0.7070312,0s0.1953125,0.5117188,0,0.7070312l-8,8 C12.2558594,16.9511719,12.1279297,17,12,17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.5f7ec6889c0f7fdd531ed899f51d81fe.svg";
export { ForwardRef as ReactComponent };